import SectionHeading from "@/components/base/SectionHeading";
import { characters } from "@/mocks/movie";

export default function Characters() {
  return (
    <section id="characters" className="w-full bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-16 md:py-24">
        <SectionHeading
          align="left"
          eyebrow="Characters"
          title="角色图鉴：每个人都在自认为正确的位置上"
          description="影片没有设置纯粹的反派，四个角色的立场单独看都站得住脚，放在一起却彼此拉扯。"
        />

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {characters.map((c) => (
            <article
              key={c.name}
              className="group rounded-lg border border-background-200 bg-background-100 overflow-hidden"
            >
              <div className="w-full aspect-square overflow-hidden">
                <img
                  src={c.image}
                  alt={`角色 ${c.name}（${c.role}）定妆照`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
                  <span className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 whitespace-nowrap">
                    {c.age}
                  </span>
                </div>
                <p className="mt-1 text-xs font-medium text-primary-600">{c.role}</p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
                <p className="mt-4 pt-3 border-t border-background-200 text-xs text-foreground-500">
                  {c.actor}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}